<template>
  <div class="conceitos_cadastro">
    <div>
      <v-btn icon to="/conceitos">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-3">
      <form @submit.prevent="onSubmit">
        <Select label="Nível" :options="optionsNivel" :disabled="hasVinculo || id > 0" v-model="form.cdinstruc" :v="$v.form.cdinstruc"/>
        <Select label="Em Uso" :options="optionsUso" v-model="form.indicauso" :v="$v.form.indicauso"/>

        <table class="table-siged mt-3">
          <thead>
            <tr>
              <th colspan="5">Conceitos</th>
            </tr>
            <tr>
              <th>Descrição</th>
              <th>Conceito</th>
              <th>Valor Inicial</th>
              <th>Valor Final</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(conceito, index) in form.conceitos" :key="conceito.identificadorconceito">
              <td class="centro">
                 <InputTable
                  type="text"
                  class="input-conceitos"
                  :disabled="hasVinculo"
                  maxlength="200"
                  v-model="conceito.descricaoconceito"
                  @blur="$v.form.conceitos.$each[index].descricaoconceito.$touch()"
                  :msgsError="msgValidacao($v.form.conceitos.$each[index].descricaoconceito)"/>
              </td>
              <td class="column_conceitos">
                <InputTable
                  type="text"
                  class="text_center input-conceitos"
                  :disabled="hasVinculo"
                  maxlength="2"
                  v-model="conceito.valorconceito"
                  @blur="$v.form.conceitos.$each[index].valorconceito.$touch()"
                  :msgsError="msgValidacao($v.form.conceitos.$each[index].valorconceito)"/>
              </td>
              <td class="column_conceitos">
                <InputTable
                  type="number"
                  class="text_center input-conceitos"
                  step="0.01"
                  :disabled="hasVinculo"
                  v-model="conceito.valorinicial"
                  @blur="$v.form.conceitos.$each[index].valorinicial.$touch()"
                  :msgsError="msgValidacao($v.form.conceitos.$each[index].valorinicial)"/>
              </td>
              <td class="column_conceitos">
                <InputTable
                  type="number"
                  class="text_center input-conceitos"
                  step="0.01"
                  :disabled="hasVinculo"
                  v-model="conceito.valorfinal"
                  @blur="$v.form.conceitos.$each[index].valorfinal.$touch()"
                  :msgsError="msgValidacao($v.form.conceitos.$each[index].valorfinal)"/>
              </td>
              <td class="centro" style="width: 8%">
                <v-btn :disabled="!isLastIndex(index) || hasVinculo" icon title="Adicionar" class="aulas-btn-acao" @click="adicionarConceito">
                  <v-icon color="green">add</v-icon>
                </v-btn>
                <v-btn :disabled="form.conceitos.length <= 1 || hasVinculo" icon title="Remover" class="aulas-btn-acao" @click="event => removerConceito(index)">
                  <v-icon color="red">close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="mt-3" style="text-align: right">
          <v-btn type="submit" :loading="loading" small dark color="teal" class="rounded-sm font-weight-regular" width="90px">Salvar</v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, minValue, maxValue, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import InputTable from '@/components/InputTable';

const ConceitosRepository = RepositoryFactory.get('conceitos');

const setFormInicial = (props) => ({
  cdinstruc: '',
  indicauso: 'S',
  conceitos: [{
    descricaoconceito: '',
    valorinicial: 0,
    valorfinal: 0,
    valorconceito: '',
    indicaativo: 'S',
  }],
});

export default {
  name: 'ConceitosCadastro',
  components: {
    InputTable,
  },
  props: {
    id: [Number, String],
  },
  data() {
    return {
      form: setFormInicial(),
      optionsNivel: [],
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      optionsUso: [
        { value: 'S', text: 'Sim' },
        { value: 'N', text: 'Não' },
      ],
    };
  },
  validations: {
    form: {
      cdinstruc: { required },
      indicauso: { required },
      conceitos: {
        required,
        $each: {
          descricaoconceito: { required, maxLength: maxLength(200) },
          valorinicial: { required, minValue: minValue(0), maxValue: maxValue(100) },
          valorfinal: { required, minValue: minValue(0), maxValue: maxValue(100) },
          valorconceito: { required, maxLength: maxLength(2) },
        },
      },
    },
  },
  async beforeRouteEnter(to, from, next) {
    try{
      const niveis = await ConceitosRepository.getNiveisEnsino();

      let editar = {};
      if(to.params.id) {
        editar = await ConceitosRepository.getGrupoConceitos(to.params.id);
      }

      next(vm => {
        vm.montarNiveis(niveis.data.results);
        if(to.params.id) { vm.load(editar.data.results); }
      });
    }
    catch(e){
      next('/conceitos');
    }
  },
  created(){
    this.$Progress.finish();
  },
  methods: {
    montarNiveis(niveis) {
      this.optionsNivel = niveis.map((key) => ({ value: key.cdinstruc, text: `${key.cdinstruc} - ${key.nivel.dsinstruc}` }));
      this.optionsNivel.unshift({ value: null, text: '' });
    },
    load(data) {
      this.form = { ...data };
    },
    removerConceito(index) {
      this.form.conceitos.splice(index, 1);
    },
    adicionarConceito() {
      this.form.conceitos.push({
        descricaoconceito: '',
        valorinicial: 0,
        valorfinal: 0,
        valorconceito: '',
        indicaativo: 'S',
      });
    },
    isLastIndex(index) {
      return index + 1 === this.form.conceitos.length;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }
      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = (this.id)? 'put' : 'post';
        const { data } = await ConceitosRepository[`${funcao}GrupoConceitos`](this.form);

        this.submitText = data.message;
        this.snackbar = true;

        setTimeout(() => {
          this.$root.$router.push({
            path: '/conceitos',
          });
        }, 1000);
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
    msgValidacao(v) {
      if(!v.required && v.$dirty) { return ['Campo obrigatório']; }
      if(typeof v.$params.maxLength !== 'undefined' && !v.maxLength && v.$dirty) { return [`O tamanho máximo é de ${v.$params.maxLength.max} caracteres`]; }
      if(typeof v.$params.minValue !== 'undefined' && !v.minValue && v.$dirty) { return [`O valor mínimo deve ser ${v.$params.minValue.min}`]; }
      if(typeof v.$params.maxValue !== 'undefined' && !v.maxValue && v.$dirty) { return [`O valor máximo deve ser ${v.$params.maxValue.max}`]; }
    },
  },
  computed: {
    hasVinculo() {
      return this.form.conceitos.some(key => key.vinculo);
    },
  },
}
</script>

<style lang="scss">
.conceitos_cadastro {
  margin: 0px 15px;

  .input-conceitos {
    width: 90%;
  }

  .column_conceitos {
    width: 13%;
    text-align: center;
  }

  .aulas-btn-acao {
    margin: 0px;
    color: #4e4e4e!important;
  }
}
</style>
